import React, { useContext, useEffect, useState, useCallback } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";
import { Link } from "react-router-dom";

export default function WithdrawalAddressHistory() {
  const { formatDateTime, formatAddress, copyaddress } = useContext(OnmaxContext);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [udata, setUdata] = useState(null);
  const username = localStorage.getItem("username");

  const getUserData = useCallback(async () => {
    if (!username) return;

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        username,
        key: process.env.REACT_APP_KEY,
      });

      if (!res.data?.error) {
        setUdata(res.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  }, [username]);

  const getData = useCallback(async () => {
    if (!username) return;

    try {
      setIsLoading(true);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "getlastadd",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,
      });

      if (res.data?.resCode !== 200) {
        setData([]);
        return;
      }

      setData(res.data.data || []);
      setPages(Math.ceil((res.data.dataLength || 0) / pageSize) || 1);
    } catch (err) {
      console.error(err);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [username, currentPage, pageSize]);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  useEffect(() => {
    getData();
  }, [getData]);

  const customStyles = `
    .bg-soft-success { background-color: rgba(34, 197, 94, 0.1) !important; color: #22c55e !important; }
    .bg-soft-warning { background-color: rgba(255, 193, 7, 0.1) !important; color: #ffc107 !important; }
    .text-slate-400 { color: #64748b !important; }
    .text-white-custom { color: #1a2234 !important; }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="db-profile-card mb-5">
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Withdrawal Address History</div>
                  </div>

                  <div className="px-4 pt-3 pb-0">
                    <Link
                      to="/wtihdrawal"
                      className="text-primary small fw-bold text-decoration-none"
                    >
                      <i className="fa fa-arrow-left me-1"></i> Back to Withdrawal
                    </Link>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table
                        className="table table-dashboard-premium align-middle mb-0"
                        style={{ minWidth: "700px" }}
                      >
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3">
                              Sr.
                            </th>
                            <th scope="col" className="py-3">
                              Address
                            </th>
                            <th scope="col" className="py-3">
                              Status
                            </th>
                            <th scope="col" className="pe-4 py-3 text-end">
                              Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="4" className="text-center py-5">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td
                                colSpan="4"
                                className="text-center py-5 text-slate-400"
                              >
                                <p className="mb-0">No records found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((e, i) => {
                              const index =
                                currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">
                                      {index}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className="text-primary cursor-pointer small"
                                      onClick={() => copyaddress(e.address)}
                                    >
                                      {e.address
                                        ? formatAddress(e.address)
                                        : "-"}{" "}
                                      {e.address &&
                                        udata?.withdrwalAddress &&
                                        e.address.toLowerCase() ===
                                          udata.withdrwalAddress.toLowerCase() && (
                                          <span className="badge bg-soft-success ms-1">
                                            Active
                                          </span>
                                        )}
                                      <i className="fa fa-copy ms-1"></i>
                                    </span>
                                  </td>
                                  <td>
                                    {e.adminApprove === false ? (
                                      <span className="badge bg-soft-warning">
                                        Pending
                                      </span>
                                    ) : (
                                      <span className="badge bg-soft-success">
                                        Verified
                                      </span>
                                    )}
                                  </td>
                                  <td className="pe-4 text-end">
                                    {e.date ? (
                                      <span className="text-slate-400 small">
                                        {formatDateTime(e.date)}
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
